module.exports = __webpack_public_path__ + "media/images/katies-049f4e77c0a4909e1ba68346e8878920.jpg";